import { requiredUuidString } from '../zod-helpers/index.js';
import { INVOICE_CONSTRAINTS } from './constraints.js';
export const invoiceIdSchema = requiredUuidString(`${INVOICE_CONSTRAINTS.invoice.label} is required.`, 'Invalid invoice selection.');
//# sourceMappingURL=rules.js.map